import './styles.scss'
import './images/carrot.svg'
import './images/hypertattoo_logo.png'
import './images/favicon.ico'